
import { motion } from "framer-motion";

export default function SectionLabel({ text }) {
  return (
    <motion.div
      className="section-label"
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-20%" }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {text}
    </motion.div>
  );
}
